export var AuthType;
(function (AuthType) {
    AuthType[AuthType["GOOGLE"] = 1] = "GOOGLE";
    AuthType[AuthType["INTERNAL"] = 10] = "INTERNAL";
    AuthType[AuthType["SAML"] = 20] = "SAML";
})(AuthType || (AuthType = {}));
//# sourceMappingURL=auth-type.enum.js.map